import { JSX } from 'react';

import * as deprecated from './deprecated-icons';
import * as icons from './icons';

export type JoshIconType = keyof typeof JoshIcons;

export function isJoshIcon(icon: string): icon is JoshIconType {
  return icon in JoshIcons;
}

export function getJoshIcon(icon: string, type: 'outlined' | 'filled' = 'outlined') {
  if (!isJoshIcon(icon)) return undefined;
  if (type === 'filled') return JoshFilledIcons[icon] ?? JoshIcons[icon];
  return JoshIcons[icon];
}

export const JoshIcons = {
  accepted: icons.AcceptedIcon,
  alerts: icons.AlertsIcon,
  attach: icons.AttachIcon,
  auto: icons.AutoIcon,
  benchmarking: icons.BenchmarkingIcon,
  bookmarks: icons.BookmarksIcon,
  building_apartment: icons.BuildingApartmentIcon,
  building_apartment_auto: icons.BuildingApartmentAutoIcon,
  building_commercial: icons.BuildingCommercialIcon, // TODO: migrate 'commercial' to this
  calendar: icons.CalendarIcon,
  categories: icons.CategoriesIcon,
  chart: icons.ChartIcon,
  chart_list: icons.ChartListIcon,
  chart_only: icons.ChartOnlyIcon,
  collapse_all: icons.CollapseAllIcon,
  collapse_sidebar: icons.CollapseSidebarIcon,
  comment: icons.CommentIcon,
  contact_support: icons.ContactSupportIcon,
  copy: icons.CopyIcon,
  dashboard: icons.DashboardIcon,
  delete: icons.DeleteIcon,
  edit: icons.EditIcon,
  edit_off: icons.EditOffIcon,
  edit_profile: icons.EditProfileIcon,
  email: icons.EmailIcon,
  email_now: icons.EmailNowIcon,
  email_scheduled: icons.EmailScheduledIcon,
  excel: icons.ExcelIcon,
  expand_all: icons.ExpandAllIcon,
  expand_sidebar: icons.ExpandSidebarIcon,
  export: icons.ExportIcon,
  focus: icons.FocusIcon,
  formula: icons.FormulaIcon,
  fullscreen_enter: icons.FullscreenEnterIcon,
  fullscreen_exit: icons.FullscreenExitIcon,
  group_by: icons.GroupByIcon,
  historical_items: icons.HistoricalItemsIcon,
  home: icons.HomeIcon,
  ideas: icons.IdeasIcon,
  incorporated: icons.IncorporatedIcon,
  insert_drive: icons.InsertDriveIcon,
  insights: icons.InsightsIcon,
  insights_classic: deprecated.InsightsClassicIcon,
  item_library: icons.ItemLibraryIcon,
  items: icons.ItemsIcon,
  keyboard_shortcuts: icons.KeyboardShortcutsIcon,
  list_only: icons.ListOnlyIcon,
  location: icons.LocationIcon,
  location_multi: icons.LocationMultiIcon,
  logout: icons.LogoutIcon,
  milestone: icons.MilestoneIcon,
  move: icons.MoveIcon,
  multilevel_categorization: icons.MultilevelCategorizationIcon,
  new: icons.NewIcon,
  not_applicable: icons.NotApplicableIcon,
  not_chosen: icons.NotChosenIcon,
  options: icons.OptionsIcon,
  paid: icons.PaidIcon,
  pending: icons.PendingIcon,
  program: icons.ProgramIcon,
  project: icons.ProjectIcon,
  rejected: icons.RejectedIcon,
  remove_circle: icons.RemoveCircleIcon,
  reports: icons.ReportsIcon,
  reports_ribbon: icons.ReportsRibbonIcon,
  restore: icons.RestoreIcon,
  restore_no_history: icons.RestoreNoHistoryIcon,
  risks: icons.RisksIcon,
  scenarios: icons.ScenariosIcon,
  search: icons.SearchIcon,
  settings: icons.SettingsIcon,
  show_direct_costs_only: icons.NoMarkupsIcon,
  show_markups_allocated: icons.AllocatedMarkupsIcon,
  show_markups_separated: icons.SeparatedMarkupsIcon,
  size: icons.SizeIcon,
  subtotals: icons.SubtotalsIcon,
  support_menu: icons.SupportMenuIcon,
  switch_calculation: icons.SwitchCalculationIcon,
  switch_report: icons.SwitchReportIcon,
  team: icons.TeamIcon,
  time: icons.TimeIcon,
  time_multi: icons.TimeMultiIcon,
  trending_abstract: icons.TrendingAbstractIcon,
  update: icons.UpdateIcon,
  upload: icons.UploadIcon,
  user: icons.UserIcon,
  user_add: icons.UserAddIcon,
  user_avatar: icons.UserAvatarIcon,
  visit_help_center: icons.VisitHelpCenterIcon,
  whats_new: icons.WhatsNewIcon,
  zoom_to_fit: icons.ZoomToFitIcon,
} as const;

export const JoshFilledIcons: Partial<Record<JoshIconType, () => JSX.Element>> = {
  location: icons.LocationFilledIcon,
  milestone: icons.MilestoneFilledIcon,
  time: icons.TimeFilledIcon,
} as const;
